<template>
  <div>
    <div v-if="loading">
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
    </div>
    <v-card>
      <v-card-title>Edit breaking news</v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="form" v-model="isValid">
          <v-text-field
            filled
            label="Title"
            v-bind:rules="validation.title"
            v-model="newsData.title"
          ></v-text-field>
          <redactor v-model="newsData.body"></redactor>

          <br />
          <v-autocomplete
            filled
            required
            autocomplete="off"
            label="Select Category"
            v-model="newsData.category_id"
            item-text="name"
            :rules="validation.category"
            item-value="id"
            v-bind:items="category"
          ></v-autocomplete>

          <v-card class="my-2">
            <v-card-title>
              Add tag (optional)
            </v-card-title>
            <v-card-text>
              <v-combobox
                v-model="newsData.content_tag"
                chips
                outlined
                clearable
                label="Add tag and press enter"
                multiple
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    aria-multiline="true"
                    @click="select"
                    @click:close="removeContentTag(item)"
                  >
                    <strong>{{ item }}</strong
                    >&nbsp;
                  </v-chip>
                </template>
              </v-combobox>
            </v-card-text>
          </v-card>

          <v-file-input
            filled
            label="Photo"
            accept="image/*"
            prepend-icon="mdi-camera"
            hide-details
            v-model="imageData"
            @change="imageInputChangedCallback"
            multiple
          >
            <template v-slot:selection> </template>
          </v-file-input>
          <div
            v-if="
              selectedImages !== null &&
                Array.isArray(selectedImages) &&
                selectedImages.length > 0
            "
          >
            <file-images
              :images="selectedImages"
              @delete_success="offlineImageDeleteCallback"
            />
          </div>
          <br />
          <v-card>
            <div
              v-if="
                serverImages !== null &&
                  Array.isArray(serverImages) &&
                  serverImages.length > 0
              "
            >
              <v-container fluid grid-list-md tile>
                <v-layout row wrap>
                  <v-flex
                    xs12
                    md6
                    v-for="item in serverImages ? serverImages : []"
                    :key="item.id"
                  >
                    <image-card
                      :image="item"
                      :id="item.id"
                      @delete_success="callbackImgDeleteSuccess"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
            <v-card-subtitle v-else>No uploaded Image</v-card-subtitle>
          </v-card>
          <br />
          <v-card>
            <v-card-title> Body Image </v-card-title>
            <v-file-input
              filled
              class="pa-4"
              label="Browse"
              accept="image/*"
              prepend-icon="mdi-image-album"
              hide-details
              @change="bodyImageInputChangedCallback"
            >
              <template v-slot:selection> </template>
            </v-file-input>
            <div
              v-if="
                selectedBodyImages !== null &&
                  Array.isArray(selectedBodyImages) &&
                  selectedBodyImages.length > 0
              "
            >
              <file-images
                :images="selectedBodyImages"
                @delete_success="offlineBodyImageDeleteCallback"
              />
            </div>
            <div
              v-if="
                serverBodyImages !== null &&
                  Array.isArray(serverBodyImages) &&
                  serverBodyImages.length > 0
              "
            >
              <v-container fluid grid-list-md tile>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <image-card
                      :image="serverBodyImages[0]"
                      :id="serverBodyImages[0].id"
                      @delete_success="callbackImgDeleteSuccess"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
            <v-card-subtitle v-else>No uploaded Image</v-card-subtitle>
          </v-card>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn
          tile
          color="primary"
          class="mx-2"
          v-on:click="update"
          :disabled="!isValid"
          v-bind:loading="loading"
          >Update</v-btn
        >
        <v-spacer />
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import postApi from '@/api/postApi'
import breakingNewsApi from '@/api/breakingNewsApi'
import snackbar from '@/utils/snackbar'
import urlUtils from '@/utils/urlUtils'
import redactor from '@/components/Redactor.vue'

export default {
  components: {
    'image-card': () => import('@/components/ImageDeleteCard'),
    'file-images': () => import('@/components/ImagesFromFiles'),
    redactor
  },
  props: {
    title: {
      type: String,
      default: 'Add News'
    }
  },
  mounted () {
    this.init()
  },
  watch: {
    'newsData.title': function (newVal, oldVal) {
      if (newVal && newVal && newVal[newVal.length - 1] === '\\') {
        this.newsData.title = oldVal !== null ? oldVal + 'ṭ' : 'ṭ'
      } else if (newVal && newVal[newVal.length - 1] === '|') {
        this.newsData.title = oldVal + 'Ṭ'
      }
    }
  },
  data () {
    return {
      isValid: null,
      loading: false,
      category: null,
      imageData: null,
      selectedImages: [],
      selectedBodyImages: [],
      serverBodyImages: [],
      serverImages: [],
      images: [],
      newsData: {
        id: null,
        title: '',
        body: '',
        images: [],
        body_image: null,
        category_id: null,
        content_tag: null,
        tag: null
      },

      validation: {
        title: [v => !!v || 'Please enter title'],
        category: [v => !!v || 'Please select category']
      }
    }
  },
  computed: {},
  methods: {
    removeContentTag (item) {
      this.newsData.content_tag.splice(
        this.newsData.content_tag.indexOf(item),
        1
      )
    },

    async bodyImageInputChangedCallback (file) {
      this.newsData.body_image = file

      if (file == null) {
        // this.selectedImages = []
        return
      }

      const reader = new FileReader()
      reader.onload = e => this.selectedBodyImages.push(e.target.result)
      reader.readAsDataURL(file)
    },
    offlineBodyImageDeleteCallback (data) {
      const index = this.selectedBodyImages.indexOf(data.file)
      if (index !== undefined && index !== null) {
        if (index > -1) {
          this.selectedBodyImages.splice(index, 1)
        }
      }
    },
    offlineImageDeleteCallback (data) {
      // clear file input view
      this.imageData = null
      const index = this.selectedImages.indexOf(data.file)
      if (index !== undefined && index !== null) {
        if (index > -1) {
          this.selectedImages.splice(index, 1)
        }
      }
    },
    async imageInputChangedCallback (file) {
      if (file == null) {
        // this.selectedImages = []
        return
      }

      file.forEach(element => {
        this.newsData.images.push(element)
        const reader = new FileReader()
        reader.onload = e => this.selectedImages.push(e.target.result)
        reader.readAsDataURL(element)
      })
    },
    async init () {
      this.loading = true
      const response = await postApi.getCategories()
      this.fetchBN()
      if (response.data !== undefined) {
        this.category = response.data
      }
    },
    getImageFullUrl (url) {
      var k = urlUtils.getImageUrl(url)
      return k
    },
    callbackImgDeleteSuccess () {
      this.fetchBN()
    },
    async fetchBN () {
      this.loading = true
      try {
        const response = await breakingNewsApi.findById(this.$route.params.id)
        if (response.data !== undefined) {
          this.assignValues(response.data)
        }
      } finally {
        this.loading = false
      }
    },
    assignValues (data) {
      this.newsData.id = data.id
      this.newsData.title = data.title
      this.newsData.body = data.body
      this.serverImages = data.images
      this.newsData.category_id = data.category.id
      this.serverBodyImages = data.body_image

      if (data.tag) {
        this.newsData.content_tag = data.tag.split(' § ')
      }
    },
    async update () {
      if (this.newsData.body === '') {
        snackbar.show('Please enter body', 'error')
        return
      }
      this.loading = true
      try {
        this.$log.info('insert new params', [this.newsData])
        const response = await breakingNewsApi.update(this.newsData)
        if (response.data !== undefined) {
          this.$log.info('breaking news update response', [response.data])
          this.selectedImages = []
          window.publish_date = response.data.publish_date
          snackbar.show('Breaking News updated successfully', 'success')
          this.$router.push({
            path: '/breaking-news',
            replace: true
          })
        }
      } finally {
        this.loading = false
      }
    },
    onEditorBlur (quill) {},
    onEditorFocus (quill) {},
    onEditorReady (quill) {}
  }
}
</script>

<style>
.ql-editor {
  min-height: 350px;
  font-size: 15px;
}
</style>
